const defaultState = {
  locals: [],
  transporters: [],
  customers: [],
  dispositions: [],
  dataTransporter: {},
};

function reducer(state = defaultState, { type, payload }) {
  switch (type) {
    case "UTILS_FETCH_LOCALS": {
      return { ...state, locals: payload };
    }
    case "UTILS_FETCH_TRANSPORTERS": {
      return { ...state, transporters: payload };
    }
    case "UTILS_FETCH_CUSTOMERS": {
      return { ...state, customers: payload };
    }
    case "UTILS_FETCH_DISPOSITIONS": {
      return { ...state, dispositions: payload };
    }
    case "UTILS_FETCH_DATA_TRANSPORTER": {
      return { ...state, dataTransporter: payload[0] };
    }
    default:
      return state;
  }
}
export default reducer;
